import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/auditTime';
import { FRAME_DURATION, isDocumentAvailable } from '../util';
import { DOMService } from './dom.service';
/**
 * @hidden
 */
var ResizeService = (function () {
    function ResizeService(_dom, _zone) {
        this._dom = _dom;
        this._zone = _zone;
    }
    ResizeService.prototype.subscribe = function (callback) {
        var _this = this;
        if (!isDocumentAvailable()) {
            return;
        }
        this._zone.runOutsideAngular(function () {
            _this.subscription = Observable
                .fromEvent(_this._dom.getWindow(), "resize")
                .auditTime(FRAME_DURATION)
                .subscribe(function () { return callback(); });
        });
    };
    ResizeService.prototype.unsubscribe = function () {
        if (!this.subscription) {
            return;
        }
        this.subscription.unsubscribe();
    };
    ResizeService.prototype.isUnsubscribed = function () {
        return this.subscription && this.subscription.closed;
    };
    return ResizeService;
}());
export { ResizeService };
ResizeService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
ResizeService.ctorParameters = function () { return [
    { type: DOMService, },
    { type: NgZone, },
]; };



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-angular-dateinputs/~/@progress/kendo-angular-popup/dist/es/services/resize.service.js
// module id = ../../../../@progress/kendo-angular-dateinputs/node_modules/@progress/kendo-angular-popup/dist/es/services/resize.service.js
// module chunks = 3